import { h } from 'preact';
import { useState } from 'preact/hooks';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import styled from 'styled-components';

const Container = ({ ...props }) => {
    return <_Container {...props} />;
};

const _Container = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0 20px;
    flex: 1 0 auto;
    padding-bottom: 100px;
`;

export default Container;
